import { cva } from 'class-variance-authority';

export const cvaPopupBg = cva(
  [
    'PopupStyles-cvaPopupInner',
    'fixed z-20 w-screen h-screen pb-5.8 px-2.4',
    'flex justify-center',
  ],
  {
    variants: {
      bottom: {
        true: ['items-end text-center'],
        false: ['flex-col gap-1.2 items-center'],
      },
    },
  }
);

export const cvaPopupInner = cva([
  'cvaPopupStyles-cvaPopup',
  'flex flex-col gap-2',
  'w-full h-fit flex-initial',
  'relative',
]);

export const cvaPopupTop = cva(
  ['cvaPopupStyles-cvaPopupIcon', 'pb-1.2 flex flex-col gap-0.8'],
  {
    variants: {
      separated: {
        true: ['border-b border-b-[3px] border-b-[#373541]'],
        false: [''],
      },
    },
  }
);

export const cvaPopupTitle = cva(['cvaPopupStyles-cvaPopupTitle', ''], {
  variants: {
    separated: {
      true: ['text-[2.4rem] font-extrabold max-w-[calc(100%-4rem)]'],
      false: ['text-[2rem] font-bold'],
    },
  },
});

export const cvaPopupText = cva([
  'cvaPopupStyles-cvaPopupText',
  'text-[1.6rem] text-[#7C7B83] font-semibold',
]);

export const cvaPopupButtons = cva([
  'cvaPopupStyles-cvaPopupButtons',
  'flex flex-col gap-1.2',
  '[&_button]:w-full',
]);
